import { configurationAPI } from './configuration';

// Upload service type
const UPLOAD_SERVICE_TYPES = {
  CLOUDINARY: 'CLOUDINARY',
  R2: 'R2',
};

// Cache config để tránh fetch nhiều lần
let uploadConfigCache = null;
const CONFIG_CACHE_TTL = 5 * 60 * 1000; // 5 phút

/**
 * Lấy config upload service từ API backend
 * Sử dụng cache để tránh fetch quá nhiều lần
 * @returns {Promise<string>} Upload service type (CLOUDINARY hoặc R2)
 */
export async function getUploadConfig() {
  // Kiểm tra cache
  if (uploadConfigCache && Date.now() - uploadConfigCache.timestamp < CONFIG_CACHE_TTL) {
    return uploadConfigCache.service;
  }

  try {
    // Fetch config từ API backend
    // Key: 'upload_service' hoặc tên key mà backend sử dụng
    const config = await configurationAPI.getConfigurationByKey('UPLOAD_SERVICE');

    if (config?.value) {
      const service = config.value.toUpperCase();

      // Validate service type
      if (Object.values(UPLOAD_SERVICE_TYPES).includes(service)) {
        uploadConfigCache = {
          service,
          timestamp: Date.now(),
        };
        return service;
      }
    }
  } catch (error) {
    // Nếu không có endpoint hoặc lỗi, dùng mặc định CLOUDINARY
    console.warn('Không thể fetch upload config từ API, dùng CLOUDINARY mặc định:', error?.message || 'Unknown error');
  }

  // Mặc định dùng CLOUDINARY
  const defaultService = UPLOAD_SERVICE_TYPES.CLOUDINARY;
  uploadConfigCache = {
    service: defaultService,
    timestamp: Date.now(),
  };
  return defaultService;
}

/**
 * Xóa cache config (dùng khi cần force refresh)
 */
export function clearUploadConfigCache() {
  uploadConfigCache = null;
}

export { UPLOAD_SERVICE_TYPES };
